import { Component, inject, signal, WritableSignal } from "@angular/core";
import { AutocompleteOptionModel, FeltAutocompleteComponent, FormRoot } from "@husbanken/designsystem-angular-forms";
import { FormControl } from "@angular/forms";
import { KommuneService } from "../../../../services/oppsummering/KommuneService";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "bko-finn-kommune-card",
  imports: [FeltAutocompleteComponent],
  templateUrl: "./finn-kommune-card.html",
  styleUrl: "./finn-kommune-card.scss",
})
export class FinnKommuneCard {
  private kommuneService = inject(KommuneService);

  data: AutocompleteOptionModel[] = undefined;
  loaded: WritableSignal<boolean> = signal(false);

  kommunenavn = this.kommuneService.kommunenavn;
  hjemmeside = this.kommuneService.hjemmeside;

  constructor() {
    // <hb-felt-autocomplete> needs complete list of data when loaded
    // The component is therefore first loaded when the data has been fetched from Kartverket.
    this.kommuneService.load().subscribe(data => {
      this.data = data;
      this.loaded.set(true);
    });

    // FormControl is set to "verdi" in AutocompleteOptionModel
    this.control.valueChanges.pipe(takeUntilDestroyed()).subscribe(value => {
      this.kommuneService.selectKommune(value);
    });
  }

  control = new FormControl(undefined);
  form = new FormRoot({ sokAdresse: this.control });
}
